<template>
  <div class="snag-creation-imagery-component d-flex justify-content-between">
    <div v-for="index in 4" :key="index" class="image-box" :class="preview[index] ? 'has-image' : ''" @click="selectImage(index)">
      <div v-show="!preview[index]" class="icon-wrapper">
        <i class="far fa-camera"></i>
      </div>

      <img v-if="preview[index]" :src="preview[index]" :alt="'Image ' + index">

      <div v-if="preview[index]" class="remove-image" @click.stop="removeImage(index)">
        <i class="fad fa-times-circle"></i>
      </div>

      <input type="file" accept="image/*" class="d-none" :id="'image-' + index" name="images[]" ref="imageInput" @change="readURL">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      preview: {
        1: null,
        2: null,
        3: null,
        4: null,
      },
    };
  },

  props: {
    //
  },

  watch: {
    //
  },

  created() {
    //
  },

  methods: {
    readURL(event) {
      if (event.target.files.length > 0) {
        const file = event.target.files[0];
        const index = event.target.id.split('-')[1];
        const reader = new FileReader();

        reader.onload = (e) => {
          this.preview[index] = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },

    selectImage(index) {
      if (this.preview[index]) {
        return;
      }

      this.$refs.imageInput[index - 1].click();
    },

    removeImage(index) {
      this.preview[index] = null;
      this.$refs.imageInput[index - 1].value = '';
    },
  },
};
</script>
